var path = '/pages/guestlists/views/pages/rsvps/import.tpl.html';
var html = "<div class=\"content-box\" ng-if=\"vm.loading || !vm.fields\">\n    <al-loader size=\"medium\"></al-loader>\n</div>\n<importer\n        ng-if=\"!vm.loading && vm.fields\"\n        type=\"rsvp\"\n        import-url=\"rsvps/import\"\n        fields=\"vm.fields\"\n        on-success=\"vm.onSuccess(response)\"\n        on-failure=\"vm.onFailure(response)\"\n></importer>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/guestlists/views/pages/rsvps/import.tpl.html
// module id = 2285
// module chunks = 1